var styles = {"quickActionGroup":"styles_quick-action-group__G9Uvl","noSpacing":"styles_no-spacing__navOB","compactSpacing":"styles_compact-spacing__ekygk","comfortableSpacing":"styles_comfortable-spacing__XyTLz","looseSpacing":"styles_loose-spacing__A3ET1"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
